import React from "react";
import Alert from "react-bootstrap/Alert";

export default function (props) {
    return <Alert className="mt-2" variant="warning">{props.children}</Alert>
}